import { useState } from "react"
import PropTypes from "prop-types"
import { api } from "utils/api"
import Icon from "components/planning_center_icon"

const AttendeeDropdown = ({ attendee, attendeeTypeNotFree }) => {
  const [showAttendeeTotals, setShowAttendeeTotals] = useState(null)

  const handleDiscountRemove = unapplyUrl => {
    return alertModal(
      {
        title: "Remove discount?",
        text: "Are you sure you want to remove this discount from the registration?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No, don't remove it",
        confirmButtonText: "Yes, remove it!",
        customClass: "destructive-warning",
        closeOnConfirm: true
      },
      () => {
        api.post(unapplyUrl).then(_resp => Turbolinks.visit())
      }
    )
  }

  return (
    <div key={attendee.id} className="dropdown summary-dropdown">
      <div
        className={`d-f d-f@print jc-sb@print ${attendee.isCanceled ? "c-neutral-500" : " "} ${
          !attendee.isCanceled &&
          (attendee.isMissingPersonalInfo ||
            !attendee.hasAllQuestionsAnswered ||
            attendee.missingFormsCount > 0)
            ? "attendee--incomplete"
            : " "
        }`}
      >
        <div>
          <button
            style={{
              paddingBottom: "8px",
              fontSize: "16px",
              display: "inline-block",
              cursor: "pointer"
            }}
            onClick={() => setShowAttendeeTotals(showAttendeeTotals ? null : attendee.id)}
          >
            <span className={`${attendee.isCanceled ? "t-strike c-neutral-500" : ""}`}>
              {attendee.name}
              {attendee.isCanceled && " (canceled)"}
            </span>
            <span
              className="c-neutral-400 font-size-5 pl-1 d-ib"
              css={{
                transform: showAttendeeTotals ? "scaleY(-1)" : "scaleY(1)",
                transition: "transform 0.2s"
              }}
            >
              <Icon symbol="general#down-chevron" />
            </span>
          </button>
        </div>
        <div className="d-f ml-a">
          {showAttendeeTotals !== attendee.id && attendee.totalMinusDiscounts}
        </div>
      </div>
      {showAttendeeTotals === attendee.id && attendeeTypeNotFree && (
        <div className="font-size-3 p-0 mb-2" style={{ color: "#777" }}>
          <dl className="d-f ai-fs jc-sb mb-2p">
            <dt>{attendee.attendeeTypeName}</dt>
            <dd>{attendee.baseCost}</dd>
          </dl>
          {attendee.addonSelections.map(aos => (
            <dl key={aos.id} className="d-f ai-c jc-sb mb-2p">
              <dt>{aos.selectionToString}</dt>
              <dd>{aos.totalCost}</dd>
            </dl>
          ))}
          {attendee.showAttendeeTotal && (
            <dl className="summary-transaction flexed-items-with-ellipsis fw-600 mt-4p mb-4p">
              <dt className="flexed-item">Subtotal</dt>
              <dd className="flexed-item">{attendee.totalCost}</dd>
            </dl>
          )}
          {attendee.discountSelections.map(ds => (
            <dl key={ds.id} className="d-f ai-fs jc-sb mb-4p">
              <dt>
                {ds.hasDiscountCode && (
                  <button
                    className="clickable c-danger mr-4p p-r t-2p"
                    onClick={() => handleDiscountRemove(ds.removeDiscountPath)}
                  >
                    <Icon symbol="general#minus-circle" />
                  </button>
                )}
                {ds.name}
              </dt>
              <dd>{ds.effectiveDiscount}</dd>
            </dl>
          ))}
          <dl className="summary-transaction flexed-items-with-ellipsis fw-600 mt-4p">
            <dt className="flexed-item">Attendee total</dt>
            <dd className="flexed-item">{attendee.totalMinusDiscounts}</dd>
          </dl>
        </div>
      )}
    </div>
  )
}

AttendeeDropdown.propTypes = {
  attendee: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    totalMinusDiscounts: PropTypes.string,
    isCanceled: PropTypes.bool,
    isMissingPersonalInfo: PropTypes.bool,
    hasAllQuestionsAnswered: PropTypes.bool,
    missingFormsCount: PropTypes.number,
    attendeeTypeName: PropTypes.string,
    baseCost: PropTypes.string,
    addonSelections: PropTypes.array,
    showAttendeeTotal: PropTypes.bool,
    totalCost: PropTypes.string,
    discountSelections: PropTypes.array
  }),
  attendeeTypeNotFree: PropTypes.bool
}

export default AttendeeDropdown
